const anime = require('animejs');
require('snapsvg');

export {};

const prevArrow = NLMK.generateSlickArrow('left', 'prev');
const nextArrow = NLMK.generateSlickArrow('right', 'next');

$(init);

NLMK.initSliders = init;
const $window = $(window);

function init() {
    $('.slider')
        .not('.slider--not-default-js')
        .each(eachSlider);
}

function eachSlider(sliderIndex, SliderElement) {
    const $slider = $(SliderElement);
    const $list = $slider.find('.slider__list');

    const slidesToShow = $list.data('slides-to-show');
    const noBreakpoints = $list.data('no-breakpoints');

    const dotsMobile = $list.data('dots-mobile');
    const slidesToShowMobile = $list.data('slides-to-show-mobile') || 1;
    const dotsAnim = $list.data('dots-anim');

    const dotsVerticalTablet = $list.data('dots-vertical-tablet');
    const slidesToShowVerticalTablet = $list.data('slides-to-show-vertical-tablet') || 2;

    const slidesToShowDesktop = $list.data('slides-to-show-desktop') || slidesToShow || 3;
    const slidesToScrollDesktop = $list.data('slides-to-scroll-desktop') || slidesToShowDesktop;
    const dotsDesktop = $list.data('dots-desktop');

    const disableTouchOnMob = $list.data('disable-touch-mob');
    const disableTouchOnVTab = $list.data('disable-touch-v-tab');

    const variableWidth = $list.data('variable-width');
    const infinite = $list.data('infinite');
    let centerMode = $list.data('center-mode');
    let initialSlide = $list.data('initial-slide') || 0;
    const adaptiveHMobile = $list.data('adaptive-height-mobile');

    const autoplayInterval = parseInt($list.data('autoplay-interval'));

    const ajax = {
        method: $list.data('ajax-method'),
        length: $list.data('ajax-length'),
        url: $list.data('ajax-url'),
    };

    let SlickInstance;

    const config = {
        dots: false,
        arrows: true,
        infinite: typeof infinite !== 'undefined' && !!infinite,
        prevArrow,
        nextArrow,
    };

    if (variableWidth) {
        config.variableWidth = true;
    } else {
        config.slidesToScroll = slidesToShow ? slidesToShow : slidesToScrollDesktop || slidesToShowDesktop;
        config.slidesToShow = slidesToShow ? slidesToShow : slidesToShowDesktop;
    }

    const finalConfig = $.extend(true, {}, config, {
        centerMode,
        initialSlide,
        mobileFirst: true,
        dots: dotsMobile,
        slidesToScroll: slidesToShowMobile,
        slidesToShow: slidesToShowMobile,
        autoplay: autoplayInterval ? true : false,
        autoplaySpeed: autoplayInterval ? autoplayInterval * 1000 : 10000,
        responsive: noBreakpoints
            ? disableTouchOnMob
                ? [
                    {
                        breakpoint: 0,
                        settings: {
                            swipe: false,
                        },
                    },
                    {
                        breakpoint: NLMK.mediaQueries.verticalTablet.min - 1,
                        settings: {
                            swipe: true,
                        },
                    }
                ]
                : null
            : [
                {
                    breakpoint: 0,
                    settings: {
                        swipe: !disableTouchOnMob,
                        adaptiveHeight: adaptiveHMobile !== 'undefined' ? adaptiveHMobile : true,
                        dots: dotsMobile,
                        slidesToScroll: slidesToShowMobile,
                        slidesToShow: slidesToShowMobile,
                    },
                },
                {
                    breakpoint: NLMK.mediaQueries.verticalTablet.min - 1,
                    settings: {
                        swipe: !disableTouchOnVTab,
                        adaptiveHeight: false,
                        dots: dotsVerticalTablet,
                        slidesToScroll: slidesToShowVerticalTablet,
                        slidesToShow: slidesToShowVerticalTablet,
                    },
                },
                {
                    breakpoint: NLMK.mediaQueries.horizontalTablet.min - 1,
                    settings: {
                        adaptiveHeight: false,
                        dots: dotsDesktop,
                        slidesToScroll: slidesToShowDesktop,
                        slidesToShow: slidesToShowDesktop,
                    },
                },
                {
                    breakpoint: NLMK.mediaQueries.desktop.min - 1,
                    settings: {
                        adaptiveHeight: false,
                        dots: dotsDesktop,
                        slidesToScroll: slidesToShowDesktop,
                        slidesToShow: slidesToShowDesktop,
                    },
                },
            ],
    });

    let currentSlide = 0;
    let $circlesFill;
    let circleLength;
    let currentAnimation;
    let SnapCircle;

    $list
        .on('init breakpoint', (evt, Slick) => {
            SlickInstance = Slick;

            if (dotsAnim && Slick.$dots) {
                Slick.$dots.find('button').each((index, Button) => {
                    $(Button)
                        .html(`<span class="slick-dot__index">${Button.textContent}</span>`)
                        .append(getDot());
                });

                $circlesFill = Slick.$dots.find('.circle-progress__fill');

                SnapCircle = new Snap($circlesFill.get(0));

                circleLength = SnapCircle.getTotalLength() || 2 * Math.PI * SnapCircle.getBBox().r1;

                SnapCircle.attr({
                    strokeDasharray: circleLength,
                    strokeDashoffset: circleLength,
                });

                animateDotCircleProgress(Slick);
            }

            $window.on(NLMK.events.TABS_CHANGE, () => {
                if (!dotsAnim) {
                    SlickInstance.refresh();
                }
            });

            $window.on(NLMK.events.TABS_CHANGE, () => {
                SlickInstance.setPosition();
            });
        })
        .on('edge', () => {
            $.ajax({
                type: ajax.method,
                url: ajax.url,
                dataType: 'json',
                success(json) {
                    console.log(json.tweets);
                },
            });
        })
        .on('beforeChange', () => {
            $slider.addClass('transitioning');
            if (SnapCircle) {
                SnapCircle.attr({
                    strokeDashoffset: circleLength,
                });
            }
        })
        .on('afterChange', (ev, Slick) => {
            $slider.removeClass('transitioning');

            currentSlide = SlickInstance.currentSlide;

            if (Slick.$dots) {
                animateDotCircleProgress(Slick);
            }
        })
        .slick(finalConfig);

    function animateDotCircleProgress(Slick) {
        if (currentAnimation) {
            currentAnimation.pause();
        }

        const $circleFill = Slick.$dots.find('.slick-active').find('.circle-progress__fill');
        const CircleFill = $circleFill[0];

        let animation = $circleFill.data('animation');

        if (!animation) {
            animation = anime({
                targets: CircleFill,
                strokeDashoffset: [anime.setDashoffset, 2],
                duration: 9000,
                easing: 'linear',
                loop: false,
                complete() {
                    Slick.next();
                },
            });

            $circleFill.data({ animation });
        } else {
            animation.restart();
        }

        currentAnimation = animation;
    }
}

function getDot() {
    return `<div>
                <svg class="circle-progress" height="44" viewBox="0 0 44 44" width="44" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none">
                        <circle class="circle-progress__axis" cx="22" cy="22" r="20" stroke="#979797"/>
                        <circle class="circle-progress__fill" cx="22" cy="22" r="20" stroke="#2c5697" stroke-linecap="round" stroke-width="3"/>
                    </g>
                </svg>
            </div>`;
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/slider.js